import { printBrowser } from "../browser";

export async function printBrowserAdapter({ job }) {
  return printBrowser({
    document: {
      type: job.document_type,
      data: job.content,
    },
    printer: job.printer,
  });
}
